export function computeProductGroupKey(
  name: string,
  isSelected: boolean
): string {
  return `${name}::${String(isSelected)}`;
}
